module.exports = __webpack_public_path__ + "img/CUW.458c133d.svg";